export const veridionPageES = {
  "seo": {
    "title": "Veridion Agentic Company Intelligence | La organización de colaboradores de IA",
    "description": "El siguiente nivel de productividad: Organisation as a Service. Una organización de colaboradores de IA entrega trabajo verificado, planificable en ciclos fijos, en sus instalaciones o en su propia nube."
  },
  "hero": {
    "kicker": "Veridion Agentic Company Intelligence",
    "title": "Un creador, infinitas soluciones.",
    "claim": "El siguiente nivel de productividad: Organisation as a Service.",
    "lead": "La IA corporativa que gobierna toda la pAIoneer Labs GmbH: una plantilla de colaboradores de IA que se integra en cada proceso de su empresa, lleva el trabajo hasta el final por sí misma y aprende con cada tarea. Las personas marcan la dirección. Todo lo demás sucede por sí solo."
  },
  "vision": {
    "lines": [
      "El software dio herramientas a las empresas.",
      "La IA les dio asistentes.",
      "Veridion les da una organización."
    ],
    "note": "La información se mueve en horas, la experiencia se jubila, los puestos siguen sin cubrirse. Una herramienta más no lo resuelve; lo resuelve una plantilla que no hay que reclutar."
  },
  "grow": {
    "title": "Lo que no sabe hacer, lo crea",
    "text": "Cuando aún no existe una capacidad para una tarea o algo no puede resolverse con los medios actuales, Veridion desarrolla por sí misma nuevos sistemas de IA arbitrariamente complejos — la IA desarrolla y hace avanzar a la propia IA: diseñados, construidos, probados y puestos en marcha. Solo la aprobación permanece en manos de la persona mediante [Intent-Driven Development](idd) (IDD).",
    "punch": "Eso significa exactamente: un creador, infinitas soluciones."
  },
  "integrate": {
    "title": "En medio de sus procesos",
    "subtitle": "Sin software nuevo, sin formación, sin migración.",
    "cards": [
      {
        "title": "En el chat corporativo",
        "text": "Se habla donde su gente ya escribe: Webex, Microsoft Teams, Zoom, Slack. Basta un mensaje."
      },
      {
        "title": "En sus herramientas",
        "text": "Gestión de proyectos, repositorios, archivo documental: se trabaja en los sistemas que ya existen, no al margen de ellos."
      },
      {
        "title": "De la oferta a la contabilidad",
        "text": "Un proceso tras otro, a su ritmo. Cuando las capacidades escasean, también un solo paquete de desarrollo o un proyecto entero."
      }
    ]
  },
  "org": {
    "title": "Una plantilla organizada como una empresa",
    "subtitle": "No imponemos una plantilla rígida a ninguna empresa: para cualquier estructura empresarial diseñamos un organigrama individual, asignamos roles y responsabilidades claros y nos adaptamos con flexibilidad. Cada Business Unit está formada por empleados de IA orquestados por Veridion que trabajan de forma totalmente automatizada hasta el [IDD](idd) Human-in-the-Loop — y cuando algo aún no es posible, Veridion desarrolla nueva IA por sí misma.",
    "execKicker": "Nivel de coordinación — totalmente automatizado hasta el IDD Human-in-the-Loop",
    "execTitle": "Organigrama a medida, roles claros e IA que desarrolla a la propia IA.",
    "execText": "Por debajo de los responsables humanos, el nivel de coordinación y las Business Units de empleados de IA operan de manera totalmente automatizada: descomponen objetivos, distribuyen el trabajo en roles y responsabilidades claramente definidos, resuelven problemas de forma autónoma y solicitan aprobaciones específicas de las personas. El humano en el bucle dirige mediante [Intent-Driven Development](idd) (IDD) — mucho más allá del código de software, como dirección conjunta entre persona e IA a través de intenciones, decisiones y escenarios de verificación. Y siempre que falta una capacidad, Veridion diseña y construye nuevos sistemas de IA arbitrariamente complejos — la IA desarrolla a la IA.",
    "units": [
      {
        "name": "Desarrollo de software",
        "text": "Responde del software del requisito a la operación: arquitectura, código, pruebas, revisiones, pipelines y la calidad que hay detrás."
      },
      {
        "name": "Electrónica y firmware",
        "text": "Responde del lado del hardware: circuitos, firmware y la elección de cada componente."
      },
      {
        "name": "Computación cuántica e IA cuántica",
        "text": "Responde de la investigación en computación cuántica e IA cuántica y convierte los resultados sólidos en productos."
      },
      {
        "name": "Ventas y marketing",
        "text": "Responde del mercado: lo observa, encuentra a los clientes objetivo, elabora dosieres, redacta textos y ofertas. El cierre lo hace una persona."
      },
      {
        "name": "Productos y operación de la plataforma",
        "text": "Responde de los productos y de la operación: estrategia, prioridades, releases, además de la supervisión, las incidencias y la capacidad de la plataforma en marcha."
      },
      {
        "name": "Administración y finanzas",
        "text": "Responde de la gestión económica: justificantes, facturas, contratos, plazos, preparados hasta la firma, que queda en sus manos."
      }
    ]
  },
  "trust": {
    "title": "En qué puede confiar",
    "cards": [
      {
        "title": "Human-in-the-Loop e IDD mucho más allá del código",
        "text": "El Intent-Driven Development ([IDD](idd)) va mucho más allá del código de software: es lo que la persona en el bucle hace junto con la IA en todas las áreas de la empresa. Personas e IA formulan conjuntamente la intención (Intent), toman decisiones vinculantes (Decisions) y definen escenarios verificables (Scenarios) antes de que la plantilla de IA ejecute de manera autónoma en ciclos fijos y planificables con aprobación humana."
      },
      {
        "title": "Comunicación optimizada con teoría de juegos",
        "text": "La gestión de proyectos y la comunicación de los colaboradores de IA están optimizadas con teoría de juegos, del colaborador individual a toda la unidad de negocio: la minuciosidad y la objeción fundamentada salen a cuenta; aprobar sin examinar, repetirse y pasar la responsabilidad cuestan. Así se impone la mejor comunicación."
      },
      {
        "title": "Explicable hasta la fuente",
        "text": "Explainable AI es aquí el principio de trabajo, no un añadido: cada resultado revela de qué ha surgido, los pasajes en el conocimiento corporativo, los datos, el procedimiento de cálculo. Lo que no tiene respaldo no se afirma."
      },
      {
        "title": "Aprende por sí solo",
        "text": "Los propios indicadores se leen tras cada pasada y las propias reglas se ajustan en consecuencia: cada proyecto en marcha mejora el conjunto."
      }
    ]
  },
  "daily": {
    "title": "Lo que ya asume hoy",
    "subtitle": "Cada día, en toda la empresa.",
    "items": [
      {
        "title": "Desarrollo",
        "text": "Código, pruebas y documentación a partir de decisiones registradas. Modernización de software heredado con pruebas golden master y back-to-back."
      },
      {
        "title": "Electrónica y firmware",
        "text": "Analizar hojas de datos, simular circuitos como gemelos digitales, desarrollar firmware y evaluar alternativas de componentes antes de fabricar nada, cerca del hardware hasta el propio sensor."
      },
      {
        "title": "Investigación cuántica",
        "text": "Leer el estado de la técnica, construir y evaluar experimentos reproducibles frente a bases de comparación clásicas, cada resultado registrado de forma trazable."
      },
      {
        "title": "Análisis de datos",
        "text": "SQL Server, MariaDB, MySQL y Oracle: plan de análisis tipado, consultas estrictamente de solo lectura, estadística calculada por el entorno de ejecución, informes a partir de un resultado versionado."
      },
      {
        "title": "Administración y finanzas",
        "text": "Contabilidad, gestión financiera y la burocracia de una sociedad: leer, clasificar y archivar justificantes; borradores de facturas y contratos incluidos."
      },
      {
        "title": "Proyectos y tareas",
        "text": "La transcripción de una reunión se convierte sin rodeos en tareas en la gestión de proyectos, y el avance fluye de vuelta: la siguiente reunión comienza en el estado actual."
      },
      {
        "title": "Conocimiento corporativo",
        "text": "Una base de conocimiento para documentos y una base de datos de grafos que vincula tareas, decisiones, personas y sistemas: contexto a lo largo de semanas y más allá de los límites de los proyectos."
      },
      {
        "title": "Investigación en Internet",
        "text": "Lo que el conocimiento corporativo no tiene, se investiga: se busca, se leen las mejores páginas y al final queda un informe en el que cada afirmación tiene su fuente numerada."
      },
      {
        "title": "Voz y reuniones",
        "text": "La empresa entera se puede dirigir desde cualquier lugar: las conversaciones habladas hacen el mismo trabajo que el chat, también de viaje desde el móvil."
      },
      {
        "title": "Trabajo de oficina con RoBuddy",
        "text": "RoBuddy cubre el puesto de trabajo: citas, correos electrónicos, formaciones y preguntas de protección de datos. Las unidades cubren el resto de la empresa."
      }
    ]
  },
  "operate": {
    "title": "Operación",
    "cards": [
      {
        "title": "En sus instalaciones o en su propia nube",
        "text": "De antemano calculamos juntos qué procesos compensan: el retorno de la inversión y el coste total están sobre la mesa. La operación corre en su hardware o en su propia nube, sin que ningún documento salga de la empresa."
      },
      {
        "title": "Con nosotros",
        "text": "pAIoneer Labs GmbH está construida así desde la base: nuestros proyectos, nuestro conocimiento corporativo y nuestra administración corren sobre Veridion. La organización desarrolla ella misma el [asistente de trading](finance) de nuestra plataforma y es la IA de su chat."
      }
    ]
  },
  "cta": {
    "title": "Consulta",
    "subtitle": "Como software de servidor en su infraestructura. El precio se comunica a petición.",
    "button": "Enviar consulta",
    "subject": "Veridion Agentic Company Intelligence"
  }
};
